import React, { useState, useEffect } from "react";
import { Checkbox } from '@progress/kendo-react-inputs';
import { Dialog } from "@progress/kendo-react-dialogs";
import { Loader } from "@progress/kendo-react-indicators";

const ViewSerialQuntity = ({ callBack, data, isFreeQuantity, businessSetting, isConvert, companyId, itemRows }) => {

    let [remaingSerialData, setRemaingSerialData] = useState([]);
    let [serialData, setSerialData] = useState([]);
    let [newSerialData, setNewSerialData] = useState([]);
    let [isLoading, setIsLoading] = useState(false);
    let [serialNo, setSerialNo] = useState('');
    
    useEffect(() => {
        setSerialData(data.selectedData);
        setRemaingSerialData(data.itemSerialNo);

    }, []);


    const onChangeSerialNo = (value, index) => {
        let updatedData = [...newSerialData];
        updatedData[index].serial_no = value;
        setNewSerialData(updatedData);
        setSerialNo(value);
    }
    const onChangeSerialNoNoAdditional1 = (value, index) => {
        let updatedData = [...newSerialData];
        updatedData[index].serialNoAdditionalValue1 = value;
        setNewSerialData(updatedData);
    }
    const onChangeSerialNoNoAdditional2 = (value, index) => {
        let updatedData = [...newSerialData];
        updatedData[index].serialNoAdditionalValue2 = value;
        setNewSerialData(updatedData);
    }
    const onCheckedChangeNew = (value, index) => {
        let updatedData = [...newSerialData];
        updatedData[index].isSelected = !updatedData[index].isSelected;
        setNewSerialData(updatedData);
    }
    const onCheckedSelect = (value, index) => {
        let updatedData = [...remaingSerialData];
        updatedData[index].isSelected = !updatedData[index].isSelected;
        if (updatedData[index].isSelected) {
            updatedData[index].isFreeQuantity = false;
        } else {
            //updatedData[index].isFreeQuantity =  true;
        }
        setRemaingSerialData(updatedData);
    }

    const onCheckedDelete = (value, index) => {
        let updatedData = [...serialData];
        updatedData[index].isDeleted = !updatedData[index].isDeleted;
        updatedData[index].isSelected = !updatedData[index].isSelected;
        setSerialData(updatedData);
    }
    const onCheckedChange = (value, index) => {
        let updatedData = [...serialData];
        updatedData[index].isSelected = !updatedData[index].isSelected;
        setSerialData(updatedData);
    }
    const addMoreSerialData = async () => {
        const hasEmptyValues = newSerialData.some(obj => 
            (businessSetting.SerialNoChk == 1 && !obj.serial_no) || 
            (businessSetting.SerialNoAdditionalChk1 == 1 && !obj.serialNoAdditionalValue1) || 
            (businessSetting.SerialNoAdditionalChk2 == 1 && !obj.serialNoAdditionalValue2)
        );
        if (hasEmptyValues) {
            alert('Some values have empty of new added serial.');
            return;
        } 
        
        let newSerial = {
            serial_id: new Date().getTime() * -1,
            serial_no: '',
            serialNoAdditionalValue1: '',
            serialNoAdditionalValue2: '',
            isFreeQuantity: isFreeQuantity,
            isSelected: true,
            isNewItem: true
        };
        setNewSerialData([...newSerialData, newSerial]);
    }
    
    const deleteSerialData = (index) => {
        let serialData = newSerialData.filter((data, i) => i !== index);
        setNewSerialData(serialData);
    }
    const saveSerialData = async () => {
        const hasEmptyValues = newSerialData.some(obj => 
            (obj.isSelected && ((businessSetting.SerialNoChk == 1 && !obj.serial_no) || 
            (businessSetting.SerialNoAdditionalChk1 == 1 && !obj.serialNoAdditionalValue1) || 
            (businessSetting.SerialNoAdditionalChk2 == 1 && !obj.serialNoAdditionalValue2)))
        );
        if (hasEmptyValues) {
            alert('Some values have empty of new added serial.');
            return;
        }
        let _remaingSerial = remaingSerialData.map((data) => ({
            ...data,
            isSelected: data.isFreeQuantity ? true : data.isSelected
        }));

        let _selectedData = [...serialData, ..._remaingSerial, ...newSerialData];
        
        const allSerialNo = _selectedData.filter((data) => data.serial_no).map((data) => data.serial_no);
        
        const counts = allSerialNo.reduce((acc, num) => {
            acc[num] = (acc[num] || 0) + 1;
            return acc;
          }, {});
        const duplicatesData = Object.keys(counts).filter(num => counts[num] > 1);
        if (duplicatesData.length > 0) {
            alert("The serial numbers ("+duplicatesData+") already exist in the system. Please try another serial number.");
            return;
        }
        const allNewSerialNo = _selectedData.filter((data) => data.serial_no && data.serial_id < 1).map((data) => data.serial_no);
        let duplicates = {success: false};
        if(allNewSerialNo.length > 0){
            setIsLoading(true);
            const response = await fetch(global.checkSerialNo, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    allSerialNo: allNewSerialNo,
                    company_id: companyId,
                }),
            });
            duplicates = await response.json();
            setIsLoading(false);
        }
        if (_selectedData.filter((element) => element.isSelected).length == 0) {
            alert('Please select at least one serial number.');
        } else if (duplicates.success) {
            alert(duplicates.message);
        } else{
            let selectedData = _selectedData.filter((element) => element.isSelected);

            let _remaingSerialData = _selectedData.filter((element) => !element.isSelected);
            _remaingSerialData = _remaingSerialData.map((data) => ({
                ...data,
                isFreeQuantity: data.isDeleted ? false : data.isFreeQuantity
            }));

            _remaingSerialData = _remaingSerialData.map(({ isDeleted, ...rest }) => rest);

            let selectedFreeData = selectedData.filter((element) => element.isFreeQuantity);
            let selectedNotFreeData = selectedData.filter((element) => !element.isFreeQuantity);

            if (selectedNotFreeData == 0) {
                alert('This item must contain at least one serial number. If you do not require it, please delete the item.');
                return;
            }

            let updatedData = {};
            updatedData = {
                ...data,
                itemSerialNo: _remaingSerialData,
                selectedData: selectedData,
                quantity: selectedNotFreeData.length,
                free_quantity: selectedFreeData.length,
                trackingType: 'Serial',
                isNewQty: false
            }
            callBack(updatedData, isFreeQuantity);
        }
    }
    let clearBottomBorder = { border: "none", outline: "none", background: "transparent" };
    return (
        <div className="webForm px-30" style={{ maxHeight: 600, overflowY: 'auto', marginBottom: 20 }}>
            <div style={{ marginBottom: '20px' }}>

                {
                    serialData.map((element, index) => {
                        return (
                            <div className="form-material row" key={index} style={{ border: '2px solid #ccc', marginBottom: 5, paddingTop: 0, padding: 15 }}>
                                <div>
                                    <span htmlFor="login-username"
                                        style={{
                                            position: 'absolute',
                                            left: '0px',
                                            top: '0px',
                                            padding: '5px',
                                            borderBottomRightRadius: 10,
                                            backgroundColor: 'thistle'
                                        }}>{index + 1}</span>
                                </div>
                                {businessSetting.SerialNoChk == 1 &&
                                    <div className="col-3">
                                        <div className="form-material open" >
                                            <input
                                                type="text"
                                                style={clearBottomBorder}
                                                value={element.serial_no}
                                                placeholder={businessSetting.SerialNoTxt}
                                                readOnly
                                            />
                                            <label htmlFor="login-username">{businessSetting.SerialNoTxt} </label>

                                        </div>
                                    </div>
                                }
                                {businessSetting.SerialNoAdditionalChk1 == 1 &&
                                    <div className="col-3">
                                        <div className="form-material open">
                                            <input
                                                type="text"
                                                style={clearBottomBorder}
                                                value={element.serialNoAdditionalValue1 ? element.serialNoAdditionalValue1 : 'NA'}
                                                placeholder={businessSetting.SerialNoAdditionalLabel1}
                                                readOnly
                                            />
                                            <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel1}</label>

                                        </div>
                                    </div>
                                }
                                {businessSetting.SerialNoAdditionalChk2 == 1 &&
                                    <div className="col-3">
                                        <div className="form-material open">
                                            <input
                                                type="text"
                                                style={clearBottomBorder}
                                                value={element.serialNoAdditionalValue2 ? element.serialNoAdditionalValue2 : 'NA'}
                                                placeholder={businessSetting.SerialNoAdditionalLabel2}
                                                readOnly
                                            />
                                            <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel2}</label>
                                        </div>
                                    </div>


                                }
                                <div>
                                    {
                                        element.isFreeQuantity &&
                                        <span htmlFor="login-username"
                                            style={{
                                                position: 'absolute',
                                                right: '0px',
                                                top: '0px',
                                                padding: '5px',
                                                backgroundColor: 'thistle'
                                            }}>FREE</span>
                                    }
                                </div>
                                {
                                    !isConvert &&
                                    <div className="col-2">
                                        <div className="form-material open">
                                            <Checkbox
                                                label={'Delete'}
                                                checked={element.isDeleted}
                                                onChange={e => onCheckedDelete(e.target.value, index)}
                                            />
                                        </div>
                                    </div>
                                }

                            </div>
                        )
                    })
                }
                {
                    remaingSerialData.length > 0 &&
                    <div>
                        <div
                            style={{
                                width: '100%',        // Full width of its parent
                                height: '1px',        // Line thickness
                                backgroundColor: '#e2e2e2', // Line color (black in this case)
                                margin: '20px 0',      // Optional: Add some margin around the line
                            }}
                        ></div>
                        <div style={{ marginTop: 10, marginBottom: 0 }}>
                            <h5> Remaining Serial </h5>
                        </div>
                    </div>
                }

                {
                    remaingSerialData.map((element, index) => {
                        return (
                            <div className="form-material row" key={index} style={{ border: '2px solid #ccc', marginBottom: 5, paddingTop: 0, padding: 15 }}>
                                {businessSetting.SerialNoChk == 1 &&
                                    <div className="col-3">
                                        <div className="form-material open">
                                            <input
                                                type="text"
                                                style={clearBottomBorder}
                                                value={element.serial_no}
                                                placeholder={businessSetting.SerialNoTxt}
                                                readOnly
                                            />
                                            <label htmlFor="login-username">{businessSetting.SerialNoTxt} </label>
                                        </div>
                                    </div>
                                }
                                {businessSetting.SerialNoAdditionalChk1 == 1 &&
                                    <div className="col-3">
                                        <div className="form-material open">
                                            <input
                                                type="text"
                                                style={clearBottomBorder}
                                                value={element.serialNoAdditionalValue1 ? element.serialNoAdditionalValue1 : 'NA'}
                                                placeholder={businessSetting.SerialNoAdditionalLabel1}
                                                readOnly
                                            />
                                            <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel1}</label>

                                        </div>
                                    </div>
                                }
                                {businessSetting.SerialNoAdditionalChk2 == 1 &&
                                    <div className="col-3">
                                        <div className="form-material open">
                                            <input
                                                type="text"
                                                style={clearBottomBorder}
                                                value={element.serialNoAdditionalValue2 ? element.serialNoAdditionalValue2 : 'NA'}
                                                placeholder={businessSetting.SerialNoAdditionalLabel2}
                                                readOnly
                                            />
                                            <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel2}</label>
                                        </div>
                                    </div>


                                }
                                {
                                    !isConvert &&
                                    <div className="col-2" >
                                        <div className="form-material open">
                                            <Checkbox
                                                label={'Select'}
                                                checked={element.isSelected}
                                                onChange={e => onCheckedSelect(e.target.value, index)}
                                            />
                                        </div>
                                    </div>
                                }

                            </div>
                        )
                    })
                }

                {
                    newSerialData.length > 0 && 
                    <div>
                        <div
                            style={{
                            width: '100%',        // Full width of its parent
                            height: '1px',        // Line thickness
                            backgroundColor: '#e2e2e2', // Line color (black in this case)
                            margin: '20px 0',      // Optional: Add some margin around the line
                            }}
                        ></div>
                        <div style={{marginTop: 10, marginBottom: -30}}>
                            <h5> New Serial </h5>
                        </div>
                    </div>
                }
                {
                    newSerialData.length > 0 && newSerialData.map((element, index) => {
                        return (
                            <div className="form-material row" key={index}>
                                {businessSetting.SerialNoChk == 1 &&
                                    <div className="col-3">
                                        <div className="form-material open">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={element.serial_no}
                                                placeholder={businessSetting.SerialNoTxt}
                                                onChange={e => onChangeSerialNo(e.target.value, index)}
                                            />
                                            <label htmlFor="login-username">{businessSetting.SerialNoTxt} </label>
                                        </div>
                                    </div>
                                }
                                {businessSetting.SerialNoAdditionalChk1 == 1 &&
                                    <div className="col-3">
                                        <div className="form-material open">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={element.serialNoAdditionalValue1}
                                                placeholder={businessSetting.SerialNoAdditionalLabel1}
                                                onChange={e => onChangeSerialNoNoAdditional1(e.target.value, index)}
                                            />
                                            <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel1}</label>

                                        </div>
                                    </div>
                                }
                                {businessSetting.SerialNoAdditionalChk2 == 1 &&
                                    <div className="col-3">
                                        <div className="form-material open">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={element.serialNoAdditionalValue2}
                                                placeholder={businessSetting.SerialNoAdditionalLabel2}
                                                onChange={e => onChangeSerialNoNoAdditional2(e.target.value, index)}
                                            />
                                            <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel2}</label>
                                        </div>
                                    </div>


                                }
                                <div className="col-3">
                                    <div className="form-material open">
                                        <Checkbox
                                            label={'Select'}
                                            checked={element.isSelected}
                                            onChange={e => onCheckedChangeNew(e.target.value, index)}
                                        />
                                    </div>
                                </div>
                                {
                                        newSerialData.length > 1 &&
                                        <div className="col-3">
                                        <div className="form-material open">
                                        <button
                                            type="button"
                                            className="btn btn-alt-primary"
                                            onClick={() => deleteSerialData(index)} >
                                            <i className="fa fa-check mr-5"></i>
                                            Delete
                                        </button>
                                        </div>
                                    </div>
                                    }
                            </div>
                        )
                    })
                }

            </div>
            {
                !isConvert &&
                <div className="row" >
                    <div className="col-12">
                        <button className="btn btn-primary" onClick={saveSerialData}>Save</button>
                        <button
                            type="button"
                            style={{marginLeft: 20}}
                            className="btn btn-alt-primary"
                            onClick={() => addMoreSerialData()} >
                            <i className="fa fa-check mr-5"></i>
                            Add more
                        </button>
                    </div>
                </div>
            }
            {
                isLoading && (
                    <Dialog >
                        <div style={{textAlign: 'center'}}>
                            <div style={{marginBottom: '20px'}}><Loader type="infinite-spinner"  /></div>
                            <span>Checking the serial number in the system, please wait...</span>
                        </div>
                    </Dialog>
                )
            }
        </div>

    )
}
export default ViewSerialQuntity